import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import ChangeOfUnit from "components/layout/ChangeOfUnit";
import Drawer from "../Drawer";
import NavbarLink from "../NavbarLink";
import useWindowSize from "hooks/windowSize";
import { pages, socials } from "./pagesMenu";
import { useTour } from "hooks/useTour";

import TourBalloon from "components/NewTour/TourBallon";
import {
  ArrowTopIcon,
  CompanyContainer,
  Container,
  ContainerWrap,
  Content,
  DrawerContainer,
  DrawerContent,
  Logo,
  MenuItemContainer,
  Nav,
  NavContainer,
  NavLogo,
  SocialContainer,
  SocialIcon,
  TopList,
} from "./styles";

type NavBarProps = {
  children: JSX.Element | JSX.Element[];
  openSubMenu?: true;
  selected?: string;
};

const NavBar = (props: NavBarProps): JSX.Element => {
  const { openSubMenu, selected, children } = props;
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );
  const [width] = useWindowSize();
  const size = useMemo(() => width, [width]);
  const [topList, setTopList] = useState(false);

  const { showTour, tourStep, tourType } = useTour();

  const goTop = (): void => {
    const header = document.getElementById("outer-container");
    header.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const header = document.getElementById("outer-container");
    if (header) {
      header.addEventListener("scroll", updateHeaderTable);
    }

    return () => {
      header.removeEventListener("scroll", updateHeaderTable);
    };
  }, [size]);

  const updateHeaderTable = (): void => {
    const headerTable = document.getElementById("headerTable");
    if (headerTable) {
      const scrolled =
        size > 1100
          ? headerTable.getBoundingClientRect().top === 0
          : headerTable.getBoundingClientRect().top <= 56;
      headerTable.style.backgroundColor = scrolled ? "#F2F2F2" : "";
      headerTable.style.boxShadow = scrolled ? "0px 4px 4px #00000014" : "";
      setTopList(scrolled);
    }
  };

  return (
    <ContainerWrap>
      <Container id="headerMobile">
        {size > 1100 ? (
          <NavContainer>
            <Nav
              showTour={
                (tourStep === 1 || tourStep === 5) &&
                tourType === "home" &&
                showTour
              }
            >
              <NavLogo>
                <Logo
                  src="/static/ultragaz-logo-white.svg"
                  alt="Ultragaz logo"
                />
              </NavLogo>

              <CompanyContainer>
                <ChangeOfUnit />
              </CompanyContainer>

              <MenuItemContainer>
                {pages(selectedUnit).map((page) => {
                  const isSelected = page.slug.includes(selected);
                  const Icon = page.icon;

                  return (
                    <NavbarLink
                      key={page?.key}
                      page={page}
                      isSelected={isSelected}
                      selected={selected}
                      Icon={Icon}
                      openSub={openSubMenu}
                    />
                  );
                })}
              </MenuItemContainer>

              <SocialContainer>
                {socials?.map((social) => (
                  <SocialIcon
                    key={social?.href}
                    href={social?.href}
                    target="_blank"
                    aria-label={social?.alt}
                    rel="external"
                  >
                    <img src={social?.img} alt={social?.alt} />
                  </SocialIcon>
                ))}
              </SocialContainer>
            </Nav>

            <Content id="outer-container">
              {children && size >= 1100 ? children : null}
            </Content>
          </NavContainer>
        ) : (
          <DrawerContainer>
            <Drawer {...props} selected={selected} openSubMenu={openSubMenu}>
              <DrawerContent>{children || null}</DrawerContent>
            </Drawer>
          </DrawerContainer>
        )}
        <TopList active={topList} onClick={() => goTop()}>
          <ArrowTopIcon />
        </TopList>
      </Container>
      {showTour && tourStep === 1 && tourType === "home" && (
        <TourBalloon
          title="Menu Lateral"
          content="Aqui estão disponíveis de maneira organizada, todas as funcionalidades do portal."
          position={{
            left: "272px",
            right: "0",
            top: "20%",
            arrowPosition: "left",
            maxWidth: null,
          }}
        />
      )}
      {showTour && tourStep === 5 && tourType === "home" && (
        <TourBalloon
          title="Mídias sociais"
          content="Conheça aqui todas as redes sociais oficiais da Ultragaz"
          position={{
            left: "272px",
            right: "0",
            bottom: "8px",
            arrowPosition: "left",
            maxWidth: null,
            arrowTop: "60%",
          }}
        />
      )}
    </ContainerWrap>
  );
};

export default NavBar;
